import { Modelo } from '@ext/index';
import * as Types from './Publicacion.types';
import moment, { Moment } from 'moment';
import { Articulo } from '@/__env/lib/Articulos';

export class IPublicacion extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Codigo: string = '';
    public Titulo: string = '';
    public Precio: number = 0;
    public Stock: number = 0;
    public Ventas: number = 0;
    public Link: string = '';
    public Planes: string = '';
    public Articulo: Articulo = new Articulo();

    public Estado: string = '';

    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.codigo = this.Codigo;
        json.estado = this.Estado;
        json.precio = this.Precio;
        json.stock = this.Stock;
        json.ventas = this.Ventas;
        json.titulo = this.Titulo;
        json.link = this.Link;
        json.ahora_12 = this.Planes;
        return json;
    }


    public set(): boolean
    {
        this.Id = this.Json.id;
        this.Codigo = this.Json.codigo;
        this.Titulo = this.Json.titulo;
        this.Estado = this.Json.estado;
        this.Precio = this.Json.precio;
        this.Stock = this.Json.stock;
        this.Ventas = this.Json.ventas;
        this.Link = this.Json.link;
        this.Planes = this.Json.ahora_12;
        if ( this.Json.articulo )
            this.Articulo = new Articulo( this.Json.articulo );

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IPublicacion )
    {
        this.Model = Model;
    }

    public Model: IPublicacion;
}